import { updateDepartureInfo } from '@/api';
import SendingReceiptMail from '@/components/common/SendingReceiptMail';
import DepartureInfoForm from '@/components/PassportValidate/DepartureInfoForm';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { routes } from '@/constants/routes.const';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IErrorState } from '@/pages/PassportValidate';
import { IGlobalState } from '@/store';
import { IUpdateDepartureInfoPayload } from '@/types/common.type';
import { format } from 'date-fns';
import { FormEventHandler, useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router';
import styled from 'styled-components';

function Departure() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    passportNumber: currPassportNumber,
    email: prevEmail,
    isUploadRequired,
    refundCondition,
    nationality,
    isCashPickup,
  } = useAppSelector((state) => state) as IGlobalState;
  const loginToken = localStorage.getItem('login');
  const [departureDate, setDepartureDate] = useState<any>('');
  const [sendingStatus, setSendingStatus] = useState<'DEFAULT' | 'IS_SENDING'>(
    'DEFAULT',
  );
  const [email, setEmail] = useState<string>(prevEmail || '');
  const [error, setError] = useState<IErrorState | undefined>();

  const departureMutation = useMutation(
    ['departureDate'],
    (payload: IUpdateDepartureInfoPayload) => updateDepartureInfo(payload),
    {
      onSuccess: async () => {
        await dispatch({
          type: 'UPDATE_USER_INFO',
          payload: { departureDate, email },
        });
        if (isUploadRequired) {
          setSendingStatus('IS_SENDING');
          if (isCashPickup) {
            history.push(routes.cashPickupIntro);
            return;
          }
        } else {
          if (isCashPickup) {
            history.push(routes.cashPickupIntro);
            return;
          }
          if (refundCondition === 'REFUND_ONLY') {
            history.push(routes.home);
            return;
          }
          if (
            refundCondition === 'REFUND_AFTER_ONLY' ||
            refundCondition === 'BOTH'
          ) {
            history.push(routes.refundProcedure);
            return;
          }
        }
      },
      onError: () => {
        alert('서버와 통신이 원활하지 않습니다.');
      },
    },
  );

  const onSubmitDepartureInfo: FormEventHandler<HTMLFormElement> | undefined = (
    e,
  ) => {
    e.preventDefault();
    if (
      !email.match(
        /[a-zA-Z0-9]{1,}@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
      )
    ) {
      setError({ message: 'Please enter a valid email.' });
      return;
    } else {
      setError(undefined);
    }
    departureMutation.mutate({
      passportNumber: currPassportNumber || loginToken,
      departureDate: format(departureDate, 'yyyy-MM-dd'),
      email,
    });
  };

  return (
    <ReceiptLayout>
      <Wrapper>
        <DepartureInfoForm
          setDepartureDate={setDepartureDate}
          email={email}
          setEmail={setEmail}
          onSubmit={onSubmitDepartureInfo}
          departureDate={departureDate}
          {...(error && { error })}
        />
        {sendingStatus === 'IS_SENDING' && (
          <SendingReceiptMail
            setSendingStatus={setSendingStatus}
            callback={() => history.push(routes.refundProcedure)}
          />
        )}
      </Wrapper>
    </ReceiptLayout>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 0 100px;
`;

export default Departure;
